import { render, staticRenderFns } from "./teacherleave.vue?vue&type=template&id=4103c572&"
import script from "./teacherleave.vue?vue&type=script&lang=js&"
export * from "./teacherleave.vue?vue&type=script&lang=js&"
import style0 from "./teacherleave.vue?vue&type=style&index=0&id=4103c572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports